// extracted by mini-css-extract-plugin
module.exports = {"container":"PlainLayout_container__UeI35","breadcrumb":"PlainLayout_breadcrumb__IR1mc","heading":"PlainLayout_heading__pQEdS","card":"PlainLayout_card__1gOf9"};